<template>
    <div>
        <draggable
            :list="computedWidgets"
            group="dashboard"
            class="card-columns">
            <div v-for="(item, index) in computedWidgets" class="card"
                 v-if="checkWidgets(item.id)" :id="checkWidgets(item.id)"
                 :key="item.order">
                <component
                    :is="checkWidgets(item.component)"
                    :ref="item.ref"
                    v-bind="item.props"
                    v-bind:appearance="appearance"
                    v-bind:tenant-id="tenantId"
                    v-bind:dashboard-id="_.get(dashboard, 'id', _.get(dashboard, 'dashboardId'))"
                >
                </component>
            </div>
        </draggable>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import SubmissionsChart from "../SubmissionsChart";
import SettledChart from "../SetteledChart";
import LeadSettlementChart from "../LeadSettlementChart";
import BrokerSettledChart from "../BrokerSettledChart";
import BrokerNafChart from "../BrokerNafChart";
import BrokerIncomeChart from "../BrokerIncomeChart";
import LenderIncomeChart from "../LenderIncomeChart";
import LenderSettledChart from "../LenderSettledChart";
import LenderNafChart from "../LenderNafChart";
import TeamSettledChart from "../TeamSettledChart";
import TeamIncomeChart from "../TeamIncomeChart";
import TeamNafChart from "../TeamNafChart";
import ActivityChart from "../ActivityChart";
import AverageIncomeChart from "../AverageIncomeChart";
import TotalIncomeChart from "../TotalIncomeChart";
import ClosedApplicationChart from "../ClosedApplicationChart";
import Settlements from "../Settlements";
import SettlementsChart from "../SettlementsChart";
import BrokerBreakdowns from "../BrokerBreakdowns";

export default {
    name: 'DashboardCharts',
    props: ['dashboard_view', 'appearance', 'tenantId', 'dashboard', 'computedWidgets'],
    components: {
        draggable,
        "submissions-chart": SubmissionsChart,
        "settled-chart": SettledChart,
        "lead-settlement-chart": LeadSettlementChart,
        "broker-settled-chart": BrokerSettledChart,
        "broker-naf-chart": BrokerNafChart,
        "broker-income-chart": BrokerIncomeChart,
        "lender-income-chart": LenderIncomeChart,
        "lender-settled-chart": LenderSettledChart,
        "lender-naf-chart": LenderNafChart,
        "team-settled-chart": TeamSettledChart,
        "team-income-chart": TeamIncomeChart,
        "team-naf-chart": TeamNafChart,
        "activity-chart": ActivityChart,
        "average-income-chart": AverageIncomeChart,
        "total-income-chart": TotalIncomeChart,
        "closed-application-chart": ClosedApplicationChart,
        "settlements": Settlements,
        "settlements-chart": SettlementsChart,
        "broker-breakdowns": BrokerBreakdowns,
    },
    data() {
        return {
            selectedWidgets: []
        }
    },
    mounted() {
        this.selectedWidgets = JSON.parse(_.get(this.dashboard, 'selected_widgets', _.get(this.dashboard, 'selectedWidgets')))

        Echo.private(`dashboard.${this.tenantId}.${_.get(this.dashboard, 'id', _.get(this.dashboard, 'dashboardId'))}`).listen(".dashboard-live", (event) => {
            this.selectedWidgets = JSON.parse(event.selectedWidgets)
        })
    },
    created() {
        this.selectedWidgets = JSON.parse(_.get(this.dashboard, 'selected_widgets', _.get(this.dashboard, 'selectedWidgets')))

        Echo.private(`dashboard.${this.tenantId}.${_.get(this.dashboard, 'id', _.get(this.dashboard, 'dashboardId'))}`).listen(".dashboard-live", (event) => {
            this.selectedWidgets = JSON.parse(event.selectedWidgets)
        })
    },
    methods: {
        checkWidgets(id) {
            let getWidgetIds = this.selectedWidgets.filter(function (elem) {
                if (_.get(elem, 'id') == id) return elem
            })

            return this.selectedWidgets && this.selectedWidgets.length > 0 ? _.map(getWidgetIds, function getId(w) {
                return w.id
            }).toString() : id
        }
    }
}
</script>

<style lang="scss" scoped>
@media (min-width: 576px) {
    .card-columns {
        column-count: 2;
    }
}

@media (min-width: 768px) {
    .card-columns {
        column-count: 3;
    }
}

@media (min-width: 992px) {
    .card-columns {
        column-count: 4;
    }
}

@media (min-width: 1200px) {
    .card-columns {
        column-count: 4;
    }
}
</style>
